import getImageUrl, { IMGIX } from '@/utils/images';
import React from 'react';
import styled from 'styled-components';

const Icon = styled.img`
  width: ${props =>
    props.small ? '80px' : props.isScrolling ? '135px' : '200px'};
  height: ${props =>
    props.small ? '30px' : props.isScrolling ? '50px' : '111px'};
  transition: height 0.2s ease;

  @media (max-width: 992px) {
    width: 80px;
    height: 30px;
  }
`;

function TheInsideLogo({
  className = '',
  small,
  isHomepage,
  isScrolling,
  horizontal = false
}) {
  const src = getLogoImage(horizontal);

  return (
    <Icon
      className={className}
      small={small}
      isHomepage={isHomepage}
      isScrolling={isScrolling}
      src={src}
      alt="logo"
    />
  );
}

function getLogoImage(horizontal) {
  if (horizontal) return getImageUrl('nav/logo-2023.svg?format=auto', IMGIX);

  return getImageUrl('nav/logo-2023.svg?format=auto', IMGIX);
}

export default TheInsideLogo;
